import { frontendURL } from 'dashboard/helper/URLHelper';
import SetupView from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/setup'),
    name: 'setup_index',
    component: SetupView,
    meta: {
      // Every step links into admin-only screens (channels, agents, AI), so
      // the page itself is admin-only, like the topbar chip that opens it.
      permissions: ['administrator'],
    },
  },
];
